/* ==========================================================================
   BELORA — SKIMS PURE · search panel (snippets/header-search.liquid)

   <sk-search> IS Prestige's <header-search> — same overlay, focus trap, page
   lock, Escape, aria-expanded on every control — with only its motion
   replaced by the reference's (vf-sk-search2-1440.json): at >=1024 the panel
   slides in from the right, 0.3s, cubic-bezier(0, 0, .2, 1), over the page
   dimming to onyx 60%; below 1024 the strip fades down from under the
   announcement bar. Leave is the reverse. Reduced motion: no movement.

   Prestige expects animation controls with `.finished` (a promise) and
   `.finish()`; Web Animations provide both.

   Also here: the clear button appears once the field holds text, as it does
   on the reference, and the idle block steps aside while results show.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 1024px)');
  var EASE = 'cubic-bezier(0, 0, .2, 1)';

  function controls(anims) {
    return {
      finished: Promise.all(anims.map(function (a) { return a.finished.catch(function () {}); })),
      finish: function () { anims.forEach(function (a) { try { a.finish(); } catch (e) {} }); },
    };
  }

  function define(Base) {
    if (window.customElements.get('sk-search')) return;
    var SkSearch = class extends Base {
      createEnterAnimationControls() {
        var dur = reduced.matches ? 0 : 300;
        var overlay = this.getShadowPartByName('overlay');
        var content = this.getShadowPartByName('content');
        var from = wide.matches ? 'translateX(100%)' : 'translateY(-8px)';
        return controls([
          overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: dur, easing: EASE, fill: 'forwards' }),
          content.animate([{ transform: from, opacity: wide.matches ? 1 : 0 }, { transform: 'none', opacity: 1 }], { duration: dur, easing: EASE, fill: 'forwards' }),
        ]);
      }
      createLeaveAnimationControls() {
        var dur = reduced.matches ? 0 : 300;
        var overlay = this.getShadowPartByName('overlay');
        var content = this.getShadowPartByName('content');
        var to = wide.matches ? 'translateX(100%)' : 'translateY(-8px)';
        return controls([
          overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: dur, easing: EASE, fill: 'forwards' }),
          content.animate([{ transform: 'none', opacity: 1 }, { transform: to, opacity: wide.matches ? 1 : 0 }], { duration: dur, easing: EASE, fill: 'forwards' }),
        ]);
      }
    };
    window.customElements.define('sk-search', SkSearch);
  }

  if (window.customElements.get('header-search')) define(window.customElements.get('header-search'));
  else window.customElements.whenDefined('header-search').then(function () { define(window.customElements.get('header-search')); });

  /* The reference puts the caret in the field on open, phones included.
     Prestige focuses it only where hover exists (so a phone keyboard does not
     jump up uninvited); on the reference it does, so: focus it inside the tap
     itself — Prestige's own click handler on <body> has already opened the
     panel by the time this one on document runs, and a focus inside the
     gesture is what lets a phone raise its keyboard. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[aria-controls^="header-search-"]');
    if (!t) return;
    var panel = document.getElementById(t.getAttribute('aria-controls'));
    if (!panel || !panel.hasAttribute('open')) return;
    var input = panel.querySelector('[data-sk-search-input]');
    if (input) input.focus({ preventScroll: true });
  });

  /* Clear button: only while there is text. The form's reset is Prestige's
     own "cleared" path (it empties the results and refocuses the field). */
  function paintClear(input) {
    var form = input.form;
    var clear = form && form.querySelector('[data-sk-search-clear]');
    if (clear) clear.hidden = !input.value;
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-sk-search-input]')) paintClear(e.target);
  });
  document.addEventListener('reset', function (e) {
    var input = e.target.querySelector && e.target.querySelector('[data-sk-search-input]');
    if (input) window.setTimeout(function () { paintClear(input); }, 0);
  }, true);
})();
